export class VtexProviderCoupom {
  public readonly name: string;

  public readonly idCalculatorConfiguration: string;

  public readonly utmSource: string;

  public readonly description: string;

  public readonly isActive: boolean;

  public readonly beginDateUtc: Date;

  public readonly endDateUtc: Date;

  public readonly nominalShippingDiscountValue: number;

  public readonly shippingPercentualTax: number;

  public readonly percentualShippingDiscountValue: number;

  public readonly absoluteShippingDiscountValue: number;

  public readonly nominalDiscountValue: number;

  public readonly nominalDiscountType: 'cart' | 'item';

  public readonly maximumUnitPriceDiscount: number;

  public readonly percentualDiscountValue: number;

  public readonly rebatePercentualDiscountValue: number;

  public readonly totalValueFloor: number;

  public readonly totalValuePurchase: number;

  public readonly itemMinPrice: number;

  public readonly itemMaxPrice: number;

  public readonly maxUsage: number;

  public readonly maxUsagePerClient: number;

  public readonly rules: string;

  constructor(props: VtexProviderCoupom) {
    this.name = props.name;
    this.idCalculatorConfiguration = props.idCalculatorConfiguration;
    this.utmSource = props.utmSource;
    this.description = props.description;
    this.isActive = props.isActive;
    this.beginDateUtc = new Date(props.beginDateUtc.toString());
    this.endDateUtc = new Date(props.endDateUtc.toString());
    this.nominalShippingDiscountValue = props.nominalShippingDiscountValue;
    this.shippingPercentualTax = props.shippingPercentualTax;
    this.percentualShippingDiscountValue =
      props.percentualShippingDiscountValue;
    this.absoluteShippingDiscountValue = props.absoluteShippingDiscountValue;
    this.nominalDiscountValue = props.nominalDiscountValue;
    this.nominalDiscountType = props.nominalDiscountType;
    this.maximumUnitPriceDiscount = props.maximumUnitPriceDiscount;
    this.percentualDiscountValue = props.percentualDiscountValue;
    this.rebatePercentualDiscountValue = props.rebatePercentualDiscountValue;
    this.totalValueFloor = props.totalValueFloor;
    this.totalValuePurchase = props.totalValuePurchase;
    this.itemMinPrice = props.itemMinPrice;
    this.itemMaxPrice = props.itemMaxPrice;
    this.maxUsage = props.maxUsage;
    this.maxUsagePerClient = props.maxUsagePerClient;
    this.rules = props.rules;
  }
}
